// extracted by mini-css-extract-plugin
export var marginNegative = "_5t-5 _5t-3 _5t-1";
export var marginPositive = "_5t-4 _5t-3 _5t-1";
export var modalContent = "_5t-6";
export var samplesTable = "_5t-8";
export var samplesTableContainer = "_5t-7";
export var statBox = "_5t-a";
export var tableCell = "_5t-1";
export var tableCellCenter = "_5t-2 _5t-1";
export var tableCellRight = "_5t-3 _5t-1";
export var tableHeader = "_5t-0";
export var trackingNumber = "_5t-9";